export const SELECTORS = {
  globalNav: '[data-pl-globalnav-role="navbar"]',
  close: '[data-pl-globalnav-role="close"]',
  open: '[data-pl-globalnav-role="open"]',
  menu: '[data-pl-globalnav-role="menu"]',
  tabIdAttr: 'data-pl-globalnav-content-id',
  backdrop: '[data-pl-globalnav-role="backdrop"]',
  panel: '[data-pl-globalnav-role="panel"]',
};

export const CLASSES = {
  openClass: 'is-open',
  panelOpenClass: 'is-panel-open',
  activeClass: 'is-selected',
};
